/**
 * StepFailedConditionType - Condition qui vérifie si une étape a échoué
 * Identique à Java StepFailedCondition
 */

import {ConditionType} from '../types/ConditionType';
import {GameState} from '../../../models/GameState';
import {PlayerStep} from '../../../models/PlayerStep';
import GameRegistry from '../../GameRegistry';
import {StepType} from '../../types/StepType';

export class StepFailedConditionType implements ConditionType {
  typeName = 'COND_STEP_FAILED';
  messageKey = 'laventurier.condition.failed.name';
  descriptionKey = 'laventurier.condition.failed.desc';
  errorKey = 'laventurier.condition.failed.error';
  hasValue = false;
  hasAttribute = false;

  evaluate(gameState: GameState, condition: any, currentStep?: PlayerStep): boolean {
    // Si currentStep n'est pas fourni, utiliser l'étape courante du gameState
    const step = currentStep || (gameState.data.currentStepNumber ? {
      numero: gameState.data.currentStepNumber,
      type: '',
    } as PlayerStep : null);

    if (!step) {
      console.log('[StepFailedConditionType] FALSE: no current step');
      return false;
    }

    // Vérifier si l'étape courante a échoué en utilisant le StepType
    try {
      const stepTypeName = step.type || 'STEP_SIMPLE';
      const stepType = GameRegistry.getStepType(stepTypeName) as StepType | undefined;
      
      if (stepType && stepType.checkFailed) {
        const result = stepType.checkFailed(gameState, step);
        console.log(`[StepFailedConditionType] ${result ? 'TRUE' : 'FALSE'}: step ${step.numero} checkFailed returned ${result}`);
        return result;
      }

      // Fallback: vérifier si le type de l'étape est STEP_FAILED ou si le gameState est FAILED
      const stepTypeUpper = stepTypeName.toUpperCase();
      const isFailedType = stepTypeUpper === 'STEP_FAILED' || stepTypeUpper === 'FAILED';
      const isGameStateFailed = gameState.state === 'FAILED';
      
      const result = isFailedType || isGameStateFailed;
      console.log(`[StepFailedConditionType] ${result ? 'TRUE' : 'FALSE'}: step ${step.numero} type=${stepTypeName}, gameState.state=${gameState.state}`);
      return result;
    } catch (error) {
      console.error('[StepFailedConditionType] Error evaluating condition:', error);
      return false;
    }
  }
}
